import { Drawer, Box, Typography, IconButton } from '@mui/material';
import { X } from 'lucide-react';
import { ICON_SIZES, ICON_STROKE } from '../constants/icons';

interface EmailPreviewDrawerProps {
  open: boolean;
  onClose: () => void;
  emailHtml: string;
  subject: string;
}

export function EmailPreviewDrawer({ open, onClose, emailHtml, subject }: EmailPreviewDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 700, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            p: 2,
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Typography variant="h6">Email Preview</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Subject: {subject}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <X size={ICON_SIZES.sm} strokeWidth={ICON_STROKE} />
          </IconButton>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            bgcolor: '#F9FAFB',
            p: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: 'white',
              borderRadius: 1,
              boxShadow: 1,
              overflow: 'hidden',
            }}
          >
            <iframe
              srcDoc={emailHtml}
              style={{
                width: '100%',
                height: '800px',
                border: 'none',
              }}
              title="Email Preview"
            />
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}
